import { Navigation, PATIENT } from "../constants";

const orderedAvailableNavUrls = {
  HOME: {
    key: Navigation.Keys.HOME,
    sortOrder: 1,
    url: "/",
    icon: "sli-home",
    title: "Home",
    shortTitle: "Home",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Home",
        shortTitle: "Home",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "pl",
        title: "Strona główna",
        shortTitle: "Strona główna",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "de",
        title: "Home",
        shortTitle: "Home",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "es",
        title: "Página de inicio",
        shortTitle: "Página de inicio",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "pt",
        title: "Página Inicial",
        shortTitle: "Página Inicial",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "tr",
        title: "Anasayfa",
        shortTitle: "Anasayfa",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "fr",
        title: "Accueil",
        shortTitle: "Accueil",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "ja",
        title: "ホーム",
        shortTitle: "Home",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
      {
        lang: "ch",
        title: "主页",
        shortTitle: "主页",
        description:
          "Welcome to the AbbVie Medical Information site. Find the answers you are searching for here.",
      },
    ],
  },
  ABOUT_US: {
    key: Navigation.Keys.ABOUTUS,
    sortOrder: 2,
    url: "/about-us",
    icon: "",
    title: "About us",
    shortTitle: "About us",
    items: [],
    translations: [
      {
        lang: "en",
        title: "About us",
        shortTitle: "About us",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "pl",
        title: "O nas",
        shortTitle: "O nas",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "de",
        title: "Über uns",
        shortTitle: "Über uns",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "es",
        title: "Sobre nosotras",
        shortTitle: "Sobre nosotras",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "pt",
        title: "Sobre nós",
        shortTitle: "Sobre nós",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "tr",
        title: "Hakkımızda",
        shortTitle: "Hakkımızda",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "fr",
        title: "À propos de nous",
        shortTitle: "À propos de nous",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "ja",
        title: "私たちに関しては",
        shortTitle: "私たちに関しては",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
      {
        lang: "ch",
        title: "关于我们",
        shortTitle: "关于我们",
        description:
          "Learn more about AbbVie's Medical Information team and mission.",
      },
    ],
  },
  PRODUCTS: {
    key: Navigation.Keys.PRODUCTS,
    sortOrder: 3,
    url: "/products",
    icon: "",
    title: "Products",
    shortTitle: "Products",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "pl",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "de",
        title: "Produkte",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "es",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "pt",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "tr",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "fr",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "ja",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
      {
        lang: "ch",
        title: "Products",
        shortTitle: "Products",
        description:
          "View names, safety data sheets, and more for our products. The product information is intended for the U.S. only.",
      },
    ],
  },
  SUBMIT: {
    key: Navigation.Keys.SUBMIT,
    sortOrder: 4,
    url: "/submit-inquiry",
    icon: "sli-pencil",
    title: "Submit Inquiry",
    shortTitle: "Submit Inquiry",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Submit Inquiry",
        shortTitle: "Submit Inquiry",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "pl",
        title: "Prześlij zapytanie",
        shortTitle: "Prześlij zapytanie",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "de",
        title: "Anfrage eingeben",
        shortTitle: "Anfrage eingeben",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "es",
        title: "Enviar consulta",
        shortTitle: "Enviar consulta",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "pt",
        title: "Enviar consulta",
        shortTitle: "Enviar consulta",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "tr",
        title: "Talep Gönder",
        shortTitle: "Talep Gönder",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "fr",
        title: "Poser une question",
        shortTitle: "Poser une question",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "ja",
        title: "問い合わせの提出",
        shortTitle: "問い合わせの提出",
        description:
          "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
      },
      {
        lang: "ch",
        title: "递交问询",
        shortTitle: "递交问询",
        description: "直接向您当地的艾伯维医学团队递交医疗信息问询。",
      },
    ],
    userTypeTranslationOverrides: {
      [PATIENT]: [
        {
          lang: "en",
          title: "Ask us a question",
          shortTitle: "Ask us a question",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "pl",
          title: "Prześlij zapytanie",
          shortTitle: "Prześlij zapytanie",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "de",
          title: "Anfrage eingeben",
          shortTitle: "Anfrage eingeben",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "es",
          title: "Enviar consulta",
          shortTitle: "Enviar consulta",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "pt",
          title: "Enviar consulta",
          shortTitle: "Enviar consulta",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "tr",
          title: "Talep Gönder",
          shortTitle: "Talep Gönder",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "fr",
          title: "Poser une question",
          shortTitle: "Poser une question",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "ja",
          title: "問い合わせの提出",
          shortTitle: "問い合わせの提出",
          description:
            "Submit an unsolicited request for Medical Information directly to your local AbbVie Medical team.",
        },
        {
          lang: "ch",
          title: "递交问询",
          shortTitle: "递交问询",
          description: "直接向您当地的艾伯维医学团队递交医疗信息问询。",
        },
      ],
    },
  },
  SEARCH: {
    key: Navigation.Keys.SEARCH,
    sortOrder: 5,
    url: "/search",
    icon: "sli-magnifier",
    title: "Search",
    shortTitle: "Search",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Search",
        shortTitle: "Search",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "pl",
        title: "Szukaj",
        shortTitle: "Szukaj",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "de",
        title: "Suchen",
        shortTitle: "Suchen",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "es",
        title: "Buscar",
        shortTitle: "Buscar",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "pt",
        title: "Pesquisar",
        shortTitle: "Pesquisar",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "tr",
        title: "Araştır",
        shortTitle: "Araştır",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "fr",
        title: "Recherche",
        shortTitle: "Recherche",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "ja",
        title: "Search",
        shortTitle: "Search",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
      {
        lang: "ch",
        title: "查询文档库",
        shortTitle: "查询文档库",
        description:
          "Search for accurate, scientific, and fair-balanced Medical Information responses to answer your questions on AbbVie products.",
      },
    ],
  },
  ALLERGEN: {
    key: Navigation.Keys.ALLERGEN,
    sortOrder: 6,
    url: "/allergen",
    icon: "sli-magnifier",
    title: "Allergen",
    shortTitle: "Allergen",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "pl",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "de",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "es",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "pt",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "tr",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "fr",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "ja",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
      {
        lang: "ch",
        title: "Ingredient/Allergens",
        shortTitle: "Ingredient/Allergens",
        description: "",
      },
    ],
  },
  CALCULATOR: {
    key: Navigation.Keys.STABTOOL,
    sortOrder: 7,
    url: "/temperature-excursion-tool",
    icon: "sli-calculator",
    title: "Temperature Excursion Tool",
    shortTitle: "Temperature Excursion Tool",
    items: [],
    // TODO: need to change Stability Tool translations to Temperature Excursion Tool
    translations: [
      {
        lang: "en",
        title: "Temperature Excursion Tool",
        shortTitle: "Temperature Excursion Tool",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "pl",
        title: "Narzędzie stabilności",
        shortTitle: "Narzędzie stabilności",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "de",
        title: "Produktstabilität",
        shortTitle: "Produktstabilität",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "es",
        title: "Herramienta de estabilidad",
        shortTitle: "Herramienta de estabilidad",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "pt",
        title: "Ferramenta de Estabilidade",
        shortTitle: "Ferramenta de Estabilidade",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "tr",
        title: "Stabilite Aracı",
        shortTitle: "Stabilite Aracı",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "fr",
        title: "Outil de stabilité",
        shortTitle: "Outil de stabilité",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "ja",
        title: "Temperature Excursion Tool",
        shortTitle: "Temperature Excursion Tool",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
      {
        lang: "ch",
        title: "Temperature Excursion Tool",
        shortTitle: "Temperature Excursion Tool",
        description:
          "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
      },
    ],
    userTypeTranslationOverrides: {
      [PATIENT]: [
        {
          lang: "en",
          title: "Medication storage",
          shortTitle: "Medication storage",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "pl",
          title: "Narzędzie stabilności",
          shortTitle: "Narzędzie stabilności",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "de",
          title: "Produktstabilität",
          shortTitle: "Produktstabilität",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "es",
          title: "Herramienta de estabilidad",
          shortTitle: "Herramienta de estabilidad",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "pt",
          title: "Ferramenta de Estabilidade",
          shortTitle: "Ferramenta de Estabilidade",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "tr",
          title: "Stabilite Aracı",
          shortTitle: "Stabilite Aracı",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "fr",
          title: "Outil de stabilité",
          shortTitle: "Outil de stabilité",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "ja",
          title: "Medication storage",
          shortTitle: "Medication storage",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
        {
          lang: "ch",
          title: "Medication storage",
          shortTitle: "Medication storage",
          description:
            "Evaluate stability of select AbbVie products following an excursion from recommended storage conditions.",
        },
      ],
    },
  },
  FINDMYMSL: {
    key: Navigation.Keys.FINDMYMSL,
    sortOrder: 8,
    url: "/find-my-msl",
    icon: "sli-magnifier",
    title: "Find My Medical Science Liaison",
    shortTitle: "Find My MSL",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Find My Medical Science Liaison",
        shortTitle: "Find My MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "pl",
        title: "Znajdź mój MSL",
        shortTitle: "Znajdź mój MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "de",
        title: "Meine MSL finden",
        shortTitle: "Meine MSL finden",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "es",
        title: 'Encuentra "Mi MSL"',
        shortTitle: "Mi MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "pt",
        title: 'Encontre "Meu MSL"',
        shortTitle: "Meu MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "tr",
        title: "MSL’imi Bul",
        shortTitle: "MSL’imi Bul",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "fr",
        title: "Trouver mon MSL",
        shortTitle: "Trouver mon MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "ja",
        title: "Find My Medical Science Liaison",
        shortTitle: "Find My MSL",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
      {
        lang: "ch",
        title: "查找我的医学联络官",
        shortTitle: "查找我的医学联络官",
        description:
          "Find your local MSL to discuss your questions about AbbVie products and other information.",
      },
    ],
  },
  SITERESOURCES: {
    key: Navigation.Keys.SITERESOURCES,
    sortOrder: 9,
    url: "/hcp-resources",
    icon: "sli-magnifier",
    title: "HCP Resources",
    shortTitle: "HCP Resources",
    items: [],
    translations: [
      {
        lang: "en",
        title: "HCP Resources",
        shortTitle: "HCP Resources",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "pl",
        title: "Zasoby HCP",
        shortTitle: "Zasoby HCP",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "de",
        title: "Ressourcen für Fachkreise",
        shortTitle: "Ressourcen",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "es",
        title: "Recursos para profesionales",
        shortTitle: "Recursos",
        longTitle:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "pt",
        title: "Recursos ao Profissional",
        shortTitle: "Recursos",
        longTitle: "Recursos ao Profissional de Saúde",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "tr",
        title: "SMM Kaynakları",
        shortTitle: "SMM Kaynakları",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "fr",
        title: "Ressources médicales",
        shortTitle: "Ressources médicales",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "ja",
        title: "HCP Resources",
        shortTitle: "HCP Resources",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
      {
        lang: "ch",
        title: "HCP Resources",
        shortTitle: "HCP Resources",
        description:
          "Links to useful resources, including Product, Clinical Trial, and Disease State Information.",
      },
    ],
    userTypeTranslationOverrides: {
      [PATIENT]: [
        {
          lang: "en",
          title: "Resources",
          shortTitle: "Resources",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "pl",
          title: "Zasoby",
          shortTitle: "Zasoby",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "de",
          title: "Ressourcen",
          shortTitle: "Ressourcen",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "es",
          title: "Recursos",
          shortTitle: "Recursos",
          longTitle:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "pt",
          title: "Recursos",
          shortTitle: "Recursos",
          longTitle: "Recursos ao Profissional de Saúde",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "tr",
          title: "Kaynakları",
          shortTitle: "Kaynakları",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "fr",
          title: "Ressources",
          shortTitle: "Ressources",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "ja",
          title: "Resources",
          shortTitle: "Resources",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
        {
          lang: "ch",
          title: "Resources",
          shortTitle: "Resources",
          description:
            "Links to useful resources, including Medication Storage, Clinical Trial, and Patient Information.",
        },
      ],
    },
  },
  CONGRESSINTEGRATION: {
    key: Navigation.Keys.CONGRESSINTEGRATION,
    sortOrder: 10,
    url: "/congresses",
    icon: "sli-magnifier",
    title: "Congresses",
    shortTitle: "Congresses",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Congresses",
        shortTitle: "Congresses",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "pl",
        title: "Kongresy",
        shortTitle: "Kongresy",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "de",
        title: "Kongresse",
        shortTitle: "Kongresse",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "es",
        title: "Congresos",
        shortTitle: "Congresos",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "pt",
        title: "Congressos",
        shortTitle: "Congressos",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "tr",
        title: "Kongreler",
        shortTitle: "Kongreler",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "fr",
        title: "Congrès",
        shortTitle: "Congrès",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "ja",
        title: "Congresses",
        shortTitle: "Congresses",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
      {
        lang: "ch",
        title: "Congresses",
        shortTitle: "Congresses",
        description:
          "Find presentations from ongoing and recent major scientific congresses.",
      },
    ],
  },
  REPORT: {
    key: Navigation.Keys.REPORT,
    sortOrder: 12,
    url: "/reports",
    icon: "sli-docs",
    title: "Reports",
    shortTitle: "Reports",
    items: [],
    translations: [
      {
        lang: "en",
        title: "Reports",
        shortTitle: "Reports",
        description: "Site management reports",
      },
      {
        lang: "pl",
        title: "Raporty",
        shortTitle: "Raporty",
        description: "Site management reports",
      },
      {
        lang: "de",
        title: "Reports",
        shortTitle: "Reports",
        description: "Site management reports",
      },
      {
        lang: "es",
        title: "Informes",
        shortTitle: "Informes",
        description: "Site management reports",
      },
      {
        lang: "pt",
        title: "Relatórios",
        shortTitle: "Relatórios",
        description: "Site management reports",
      },
      {
        lang: "tr",
        title: "Raporlar",
        shortTitle: "Raporlar",
        description: "Site management reports",
      },
      {
        lang: "fr",
        title: "Rapports",
        shortTitle: "Rapports",
        description: "Site management reports",
      },
      {
        lang: "ja",
        title: "Reports",
        shortTitle: "Reports",
        description: "Site management reports",
      },
      {
        lang: "ch",
        title: "Reports",
        shortTitle: "Reports",
        description: "Site management reports",
      },
    ],
  },
  ADMIN: {
    key: Navigation.Keys.ADMIN,
    sortOrder: 13,
    url: "/admin/add-products",
    icon: "sli-settings",
    title: "Admin Panel",
    shortTitle: "Admin",
    items: [
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 1,
        url: "/admin/add-products",
        icon: "",
        title: "Products Administration",
        child_items: [
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 1,
            child_url: "/admin/add-products",
            icon: "",
            child_title: "Add a New Product",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 2,
            child_url: "/admin/edit-products",
            icon: "",
            child_title: "Edit Product",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 3,
            child_url: "/admin/affiliate-product-visibility",
            icon: "",
            child_title: "Affiliate Product Visbility",
            items: [],
          },
          // {
          //   key: Navigation.Keys.ADMIN,
          //   sortOrder: 3,
          //   child_url: '/admin/local-products',
          //   icon: '',
          //   child_title: 'Manage Products',
          //   items: []
          // },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 4,
            child_url: "/admin/indications",
            icon: "",
            child_title: "Add/Remove Product Indications",
            child_items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 5,
            child_url: "/admin/new-manage-indications",
            icon: "",
            child_title: "Manage Indications",
            items: [],
          },
        ],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 2,
        url: "/admin/manage-tet-products",
        icon: "",
        title: "Temperature Excursion",
        child_items: [
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 1,
            child_url: "/admin/add-tet-product",
            icon: "",
            child_title: "Add TET Product",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 2,
            child_url: "/admin/manage-tet-products",
            icon: "",
            child_title: "Manage TET Products",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 3,
            child_url: "/admin/manage-tet-rule",
            icon: "",
            child_title: "Manage TET Rule Configurations",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 4,
            child_url: "/admin/manage-tet-content",
            icon: "",
            child_title: "Manage TET Content",
            items: [],
          },
        ],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 3,
        url: "/admin/manage-translations-draft",
        icon: "",
        title: "Translations",
        child_items: [
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 1,
            child_url: "/admin/manage-translations-draft",
            icon: "",
            child_title: "Manage Translations Draft",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 2,
            child_url: "/admin/edit-translations-draft",
            icon: "",
            child_title: "Edit Translations in Draft",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 3,
            child_url: "/admin/manage-translations-live",
            icon: "",
            child_title: "Manage Translations Live",
            items: [],
          },
        ],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 4,
        url: "/admin/adgroups",
        icon: "",
        title: "Manage Search AD Groups",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 5,
        url: "/admin/manage-congresses",
        icon: "",
        title: "Manage Congresses",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 6,
        url: "/admin/manage-site-messages",
        icon: "",
        title: "Manage Site Messages",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 7,
        url: "/admin/manage-country-menu",
        icon: "",
        title: "Manage Country Menu / Functionalities",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 8,
        url: "/admin/site-export",
        icon: "",
        title: "Export Content",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 9,
        url: "/admin/ami_chatbot_admin",
        icon: "",
        title: "AMI Chatbot Admin",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 10,
        url: "/admin/audit-history",
        icon: "",
        title: "Audit History",
        child_items: [],
      },
      {
        key: Navigation.Keys.ADMIN,
        sortOrder: 11,
        url: "/admin/create-static-page",
        icon: "",
        title: "Content Management",
        child_items: [
          // {
          //   key: Navigation.Keys.ADMIN,
          //   sortOrder: 1,
          //   child_url: "/admin/upload-image",
          //   icon: "",
          //   child_title: "Upload Image",
          //   items: [],
          // },
          // {
          //   key: Navigation.Keys.ADMIN,
          //   sortOrder: 2,
          //   child_url: "/admin/get-image",
          //   icon: "",
          //   child_title: "Preview Image",
          //   items: [],
          // },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 1,
            child_url: "/admin/create-static-page",
            icon: "",
            child_title: "Create Static Page",
            items: [],
          },
          {
            key: Navigation.Keys.ADMIN,
            sortOrder: 2,
            child_url: "/admin/manage-static-page",
            icon: "",
            child_title: "Manage Static Pages",
            items: [],
          },
        ],
      },
    ],
    translations: [
      {
        lang: "en",
        title: "Admin Panel",
        shortTitle: "Admin",
        description: "Site administration functions",
      },
      {
        lang: "pl",
        title: "Administracja",
        shortTitle: "Administracja",
        description: "Site administration functions",
      },
      {
        lang: "de",
        title: "Administration",
        shortTitle: "Administration",
        description: "Site administration functions",
      },
      {
        lang: "es",
        title: "Panel de administrador",
        shortTitle: "Administrador",
        description: "Site administration functions",
      },
      {
        lang: "pt",
        title: "Painel de administração",
        shortTitle: "Administração",
        description: "Site administration functions",
      },
      {
        lang: "tr",
        title: "Admin Paneli",
        shortTitle: "Admin Paneli",
        description: "Site administration functions",
      },
      {
        lang: "fr",
        title: "Interface d’administration",
        shortTitle: "Administration",
        description: "Site administration functions",
      },
      {
        lang: "ja",
        title: "Admin Panel",
        shortTitle: "Admin",
        description: "Site administration functions",
      },
      {
        lang: "ch",
        title: "Admin Panel",
        shortTitle: "Admin",
        description: "Site administration functions",
      },
    ],
  },
};

const getExpandBreakpoint = (menuSize) => {
  if (menuSize < 7) {
    return "md";
  }
  if (menuSize < 10) {
    return "lg";
  }
  return "xl";
};

function constructNavigation(permissions, selectedLanguage, userType) {
  const permissibleNavUrls = [orderedAvailableNavUrls.HOME];

  permissions.forEach((p) => {
    if (orderedAvailableNavUrls[p]) {
      const allowedURL = { ...orderedAvailableNavUrls[p] };
      if (
        allowedURL.userTypeTranslationOverrides &&
        allowedURL.userTypeTranslationOverrides[userType]
      ) {
        allowedURL.translations =
          allowedURL.userTypeTranslationOverrides[userType];
      }
      permissibleNavUrls.push(allowedURL); //AS commented to disable TET CHG00312508 22 MAY 2024
      //Added below 3 lines of code
      //   if(p!='CALCULATOR' && p!=5){
      //   permissibleNavUrls.push(allowedURL)
      // }
      //Commented below 3 lines for enabling the TET
    }
  });

  // permissibleNavUrls.push(orderedAvailableNavUrls.ADMIN) // ::: Ran Bypass Admin Role
  // permissibleNavUrls.push(orderedAvailableNavUrls.REPORT) // ::: Ran Bypass Report Role
  // permissibleNavUrls.push(orderedAvailableNavUrls.CONGRESSES) // ::: Ran Bypass Congresses Role

  permissibleNavUrls.sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });

  return [
    {
      title: "Navigation",
      items: permissibleNavUrls,
      siteMap: {
        sections: {
          globalNavigation: {
            title: {
              name: "Global Navigation",
              translations: [
                { lang: "en", value: "Global Navigation" },
                { lang: "pl", value: "Globalna nawigacja" },
                { lang: "de", value: "Globale Navigation" },
                { lang: "es", value: "Navegación global" },
                { lang: "pt", value: "Navegação Global" },
                { lang: "tr", value: "Global Navigasyon" },
                { lang: "fr", value: "Navigation globale" },
                { lang: "ja", value: "Global Navigation" },
                { lang: "ch", value: "Global Navigation" },
              ],
            },
          },
          about: {
            title: {
              name: "About",
              translations: [
                { lang: "en", value: "About" },
                { lang: "pl", value: "O" },
                { lang: "de", value: "Über" },
                { lang: "es", value: "Acerca de" },
                { lang: "pt", value: "Sobre" },
                { lang: "tr", value: "Hakkında" },
                { lang: "fr", value: "À propos" },
                { lang: "ja", value: "About" },
                { lang: "ch", value: "About" },
              ],
            },
            items: [
              {
                key: "CLINICAL_RESEARCH_AND_INNOVATION",
                sortOrder: 1,
                url: "https://www.abbvie.com/our-science/clinical-trials/clinical-trials-data-and-information-sharing.html",
                icon: "sli-docs",
                title: "Clinical Trials Data & Information Sharing",
                items: [],
                translations: [
                  {
                    lang: "en",
                    title: "Clinical Trials Data & Information Sharing",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "pl",
                    title:
                      "Udostępnianie danych i informacji z badań klinicznych",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "de",
                    title:
                      "Daten- und Informationsaustausch für klinische Studien",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "es",
                    title:
                      "Intercambio de datos e información de ensayos clínicos",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "pt",
                    title:
                      "Compartilhamento de informações e dados de ensaios clínicos",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "tr",
                    title: "Klinik Araştırmalar Verileri ve Bilgi Paylaşımı",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "fr",
                    title:
                      "Partage de données et d'informations sur les essais cliniques",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                  {
                    lang: "ch",
                    title: "Clinical Trials Data & Information Sharing",
                    description:
                      "了解艾伯维如何致力于对我们申办的临床试验负责的透明度",
                  },
                  {
                    lang: "ja",
                    title: "Clinical Trials Data & Information Sharing",
                    description:
                      "Discover how AbbVie is committed to responsible transparency regarding the clinical trials we sponsor.",
                  },
                ],
              },
              {
                key: "ABBVIE_GLOBAL",
                sortOrder: 2,
                url: "https://www.abbvie.com/",
                icon: "sli-docs",
                title: "AbbVie Global",
                items: [],
                translations: [
                  {
                    lang: "en",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "pl",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "de",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "es",
                    title: "AbbVie global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "pt",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "tr",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "fr",
                    title: "AbbVie globale",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "ja",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                  {
                    lang: "ch",
                    title: "AbbVie Global",
                    description:
                      "AbbVie combines advanced science, expertise and passion to solve the world’s most serious health issues and have a remarkable impact on people’s lives.",
                  },
                ],
              },
            ],
          },
          legal: {
            title: {
              name: "Legal",
              translations: [
                { lang: "en", value: "Legal" },
                { lang: "pl", value: "Prawny" },
                { lang: "de", value: "Legal" },
                { lang: "es", value: "Legal" },
                { lang: "pt", value: "Legal" },
                { lang: "tr", value: "Yasal" },
                { lang: "fr", value: "Légal" },
                { lang: "ja", value: "Legal" },
                { lang: "ch", value: "Legal" },
              ],
            },
            items: [
              {
                key: "TERMS_OF_USE",
                sortOrder: 1,
                url: "https://www.abbvie.com/termsofuse.html",
                icon: "sli-docs",
                title: "Terms of Use",
                items: [],
                translations: [
                  {
                    lang: "en",
                    title: "Terms of Use",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "pl",
                    title: "Warunki korzystania",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "de",
                    title: "Nutzungsbedingungen",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "es",
                    title: "Términos de Uso",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "pt",
                    title: "Termos de uso",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "tr",
                    title: "Kullanım Şartları",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "fr",
                    title: "Conditions d'utilisation",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "ja",
                    title: "Terms of Use",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "ch",
                    title: "Terms of Use",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                ],
              },
              {
                key: "PRIVACY_POLICY",
                sortOrder: 1,
                url: "https://privacy.abbvie/privacy-policies.html",
                icon: "sli-docs",
                title: "Privacy Policy",
                items: [],
                translations: [
                  {
                    lang: "en",
                    title: "Privacy Policy",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "pl",
                    title: "Polityka prywatności",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "de",
                    title: "Datenschutz-Bestimmungen",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "es",
                    title: "Política de privacidad",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "pt",
                    title: "Política de Privacidade",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "tr",
                    title: "Gizlilik Politikası",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "fr",
                    title: "Politique de confidentialité",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "ch",
                    title: "Privacy Policy",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                  {
                    lang: "ja",
                    title: "Privacy Policy",
                    description:
                      "This online Privacy Notice explains how AbbVie handles your personal information.",
                  },
                ],
              },
              {
                key: "COOKIES_SETTINGS",
                sortOrder: 1,
                url: "https://www.abbvie.com/cookiessettings.html",
                icon: "sli-docs",
                title: "Cookies Settings",
                items: [],
                translations: [
                  {
                    lang: "en",
                    title: "Cookies Settings",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "pl",
                    title: "Ustawienia plików cookies",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "de",
                    title: "Cookies-instellingen",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "es",
                    title: "Configuración de cookies",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "pt",
                    title: "Configurações de cookies",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "tr",
                    title: "Çerez Ayarları",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "fr",
                    title: "Paramètres des cookies",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },

                  {
                    lang: "ja",
                    title: "Cookies Settings",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                  {
                    lang: "ch",
                    title: "Cookies Settings",
                    description:
                      "These Online Terms of Use govern your access to web sites controlled by AbbVie, including its subsidiaries and affiliates.",
                  },
                ],
              },
            ],
          },
        },
      },
    },
    {
      expandBreakpoint: getExpandBreakpoint(permissibleNavUrls.length),
    },
  ];
}

export function navigation(
  state = constructNavigation([]),
  { type, permissions, selectedLanguage, userType }
) {
  switch (type) {
    case "SET_PERMISSIONS":
      return constructNavigation(permissions, selectedLanguage, userType);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js